import React from "react";
import { Subscription } from "rxjs";
import { ITabSetCategory } from "../../interfaces/ITabSetCategory";
import { ITabSetCategoriesAndHtml } from "../../interfaces/ITabSetCategoryAndHtml";
import { TabSetsService } from "../../utilities/tabSetsService";
import InkAndTonerFinder from "../inkAndTonerFinder/inkAndTonerFinder";
import MegaMenuTemplate from "../megaMenu/megaMenuTemplate";

export interface IMegaMenuWrapperProps {
  category: ITabSetCategory;
  defaultSortOrderSearch: string;
}

export interface IMegaMenuWrapperState {
  megaMenuHtml: string;
  megaMenuCategories: ITabSetCategory[];
}

class MegaMenuWrapper extends React.Component<
  IMegaMenuWrapperProps,
  IMegaMenuWrapperState
> {
  private tabsetCategoriesSub: Subscription | undefined;

  constructor(props: IMegaMenuWrapperProps) {
    super(props);

    this.state = {
      megaMenuHtml: "",
      megaMenuCategories: [],
    };
  }

  componentDidMount() {
    this.tabsetCategoriesSub = TabSetsService.getSubCategories(
      this.props.category.id
    ).subscribe((response: ITabSetCategoriesAndHtml) => {
      this.setState({
        megaMenuCategories: response.categories,
        megaMenuHtml: response.html,
      });
    });
  }

  componentWillUnmount() {
    if (this.tabsetCategoriesSub) {
      this.tabsetCategoriesSub.unsubscribe();
    }
  }

  render() {
    return (
      <MegaMenuTemplate
        mobile
        defaultSortOrderSearch={this.props.defaultSortOrderSearch}
        html={this.state.megaMenuHtml}
        categories={this.state.megaMenuCategories}
        child={
          this.props.category.inkAndToner ? (
            <InkAndTonerFinder isMobile />
          ) : null
        }
      />
    );
  }
}

export default MegaMenuWrapper;
